/**
 * Integrations for the SELECTED SITE.
 *
 * The page is shared with the local app; this file supplies what is cloud-specific: the site's
 * name, so an operator describing a VMS connection can see which of twenty sites they are
 * describing it for, and the path to the site's own bulk importer.
 */
import { IntegrationsPage as SharedIntegrationsPage, Callout, PageTitle } from '@trinetra/shared';
import { useNode } from '../contexts/NodeContext';

export default function IntegrationsPage() {
  const { selectedNode, selectedNodeId } = useNode();

  // Integrations are configured against one site's cameras and one site's analytics, so the
  // estate scope has nothing to show — same rule as the Settings page it is opened from.
  if (!selectedNodeId) {
    return (
      <div className="space-y-3">
        <PageTitle title="Integrations" />
        <Callout tone="info">
          An integration connects one site to one outside system. Pick a site in the switcher above and
          its integrations appear here.
        </Callout>
      </div>
    );
  }

  return (
    <SharedIntegrationsPage
      backTo="/settings"
      siteName={selectedNode?.name}
      // The cloud has a real importer now, for the selected site — so the preview panel defers
      // to it here exactly as it does on the node.
      bulkUploadPath="/cameras/import"
    />
  );
}
